import React, { useState, useEffect, useContext } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { StateContext } from '../../../utils/context';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation }from 'react-i18next';

const PromoBannerHeader = () => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [isExpired, setIsExpired] = useState(false);
  const { currentUser } = useContext(StateContext);
  const { promo_code, has_subscription } = currentUser;

  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard' || location.pathname === '/';

  useEffect(() => {
    if (!promo_code || !promo_code.expires_at) return;

    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const expiryTime = new Date(promo_code.expires_at).getTime();
      const difference = expiryTime - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        setTimeLeft({ days, hours, minutes, seconds });
        setIsExpired(false);
      } else {
        setIsExpired(true);
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [promo_code]);

  if (!promo_code || !promo_code.code || isExpired) {
    return null;
  }

  const formatTime = () => {
    return `${timeLeft.days}d ${String(timeLeft.hours).padStart(2, '0')}h ${String(timeLeft.minutes).padStart(2, '0')}m ${String(timeLeft.seconds).padStart(2, '0')}s`;
  };

  return (
    <div className="mt-2 mr-3">
    {
      (promo_code && !isDashboard && !has_subscription) && (
          <UncontrolledDropdown nav inNavbar>
          <DropdownToggle 
            nav 
            caret 
            className="d-flex align-items-center"
            style={{
              background: 'linear-gradient(135deg, #ff6666 0%, #ff6666 100%)',
              borderRadius: '8px',
              padding: '11px 14px',
              color: 'white',
              fontSize: '14px',
              fontWeight: 'bold',
              border: 'none',
              minWidth: '120px',
              justifyContent: 'center'
            }}
          >
            <i className="ti-gift me-1 pr-2" style={{ fontSize: '16px' }}></i>
            <span className="d-none d-md-inline">{promo_code.discount}% {t('general.promoBannerHeader.off')}</span>
            <span className="d-md-none">{promo_code.discount}%</span>
          </DropdownToggle>
          <DropdownMenu right className="promo-dropdown" style={{ 
            minWidth: '280px',
            border: 'none',
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            borderRadius: '12px',
            overflow: 'hidden'
          }}>
            <div style={{ 
              background: 'linear-gradient(135deg, #ff6666 0%, #ff6666 100%)',
              padding: '16px',
              color: 'white'
            }}>
              <div className="d-flex align-items-center mb-2">
                <i className="ti-gift me-2 pr-2" style={{ fontSize: '16px' }}></i>
                <span style={{ fontSize: '14px', fontWeight: 'bold' }}>
                  {t('general.promoBannerHeader.exclusiveOfferFor')} {currentUser.first_name} ({promo_code.discount}% {t('general.promoBannerHeader.off')})
                </span>
              </div>
              
              <div className="mb-3">
                <div className="d-flex align-items-center">
                  <span style={{ fontSize: '12px', marginRight: '8px' }}>{t('general.promoBannerHeader.promoCode')}</span>
                  <div 
                    className="bg-white px-3 py-1 rounded-pill fw-bold"
                    style={{ 
                      fontSize: '14px', 
                      letterSpacing: '1px',
                      color: '#000a60'
                    }}
                  >
                    {promo_code.code}
                  </div>
                </div>
              </div>
    
              <div className="mb-3">
                <div className="d-flex align-items-center">
                  <span style={{ fontSize: '12px', marginRight: '8px' }}>{t('general.promoBannerHeader.expiresIn')}</span>
                  <div 
                    className="bg-white px-3 py-1 rounded-pill fw-bold"
                    style={{ 
                      fontSize: '14px', 
                      letterSpacing: '1px',
                      color: '#000a60',
                      marginLeft: '14px'
                    }}
                  >
                    {formatTime()}
                  </div>
                </div>
              </div>

              <Link to="/" style={{ fontSize: '14px', fontWeight: 'bold' }} className="text-underline text-center">{t('general.promoBannerHeader.clickHereToAvailThisOffer')}</Link>
            </div>

            <div 
              className="text-center align-items-center pt-1"
              style={{ 
                fontSize: '12px',
                fontWeight: 'bold',
                color: '#000a60',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <i className="ti-bolt"></i>
              {t('general.promoBannerHeader.availableOnAllSubscriptionPlans')}
            </div>
          </DropdownMenu>
        </UncontrolledDropdown>     
      )
    }
    </div>
  );
};

export default PromoBannerHeader;
